import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import DataTable from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { RappiTopOutlineIcon } from '@rappi/rests-commons-front';
import { countryByCode } from '../../constants/countries';
import { useGlobal } from '../../context/global/global.context';
import { useTopHunter } from '../../hooks/use-top-hunter';
import { TrophyIcon } from '../../icons/trophy';
import { formatDate } from '../../utils/format-date';
import { customTableStyles, TableContainer } from '../menu-generator-table/styles';
import { OwnStats } from '../own-stats/own-stats';
import { conditionalRowStyles } from './styles';
export const Top10Table = ({ country }) => {
    const { t } = useTranslation();
    const { data: topHunter } = useTopHunter(country);
    const { state } = useGlobal();
    const { auth } = state;
    const columns = [
        {
            wrap: true,
            name: t('menuGenerator.table.top10.columns.rank'),
            selector: (row) => row.ranking || 0,
            cell: (row) => (_jsxs("div", { style: { display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '4px', alignItems: 'center' }, children: [_jsxs("div", { style: { minWidth: '20px' }, children: [row.ranking, "\u00B0"] }), row.ranking === 1 && _jsx(TrophyIcon, { size: 16, color: '#DDA63A' }), (row.ranking === 2 || row.ranking === 3) && _jsx(RappiTopOutlineIcon, { size: 16, color: '#DDA63A' })] })),
            width: '100px',
        },
        {
            wrap: true,
            name: t('menuGenerator.table.top10.columns.name'),
            selector: (row) => row.hunter_name || row.hunter_email.split('@')[0].replace('.', ' '),
            style: { textTransform: 'capitalize' },
        },
        {
            wrap: true,
            name: t('menuGenerator.table.top10.columns.country'),
            selector: (row) => countryByCode[row.country].name,
            omit: !!country,
        },
        {
            wrap: true,
            name: t('menuGenerator.table.top10.columns.lastMenuUpdated'),
            selector: (row) => (row.last_updated ? formatDate(row.last_updated) : '-'),
        },
        {
            wrap: true,
            name: t('menuGenerator.table.top10.columns.totalMenus'),
            selector: (row) => row.total,
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(OwnStats, { country: country }), _jsx(TableContainer, { children: _jsx(DataTable, { responsive: true, persistTableHead: true, columns: columns, data: topHunter, customStyles: customTableStyles, conditionalRowStyles: [
                        ...conditionalRowStyles,
                        {
                            when: (row) => { var _a; return row.hunter_email === ((_a = auth === null || auth === void 0 ? void 0 : auth.userProfile) === null || _a === void 0 ? void 0 : _a.email); },
                            style: {
                                backgroundColor: '#E0FBFA',
                                fontWeight: '600',
                                '& > div': {
                                    color: '#21938D',
                                },
                            },
                        },
                    ], noDataComponent: null }) })] }));
};
